import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { UserService } from './user.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private _userService: UserService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const authReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + this._userService.getUserToken())
        });
        return next.handle(authReq);
    }
}


// WEBPACK FOOTER //
// ./src/app/service/token.interceptor.ts